import React, { useEffect, useState } from "react";
import { api, formatDateBR } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { Plus, CheckCircle2, Trash2 } from "lucide-react";
import { toast } from "../hooks/use-toast";

export default function Revisoes() {
  const [items, setItems] = useState([]);
  const [disciplines, setDisciplines] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ discipline_id: "", topic: "", next_date: "" });

  const load = async () => {
    const [r, d] = await Promise.all([api.get("/revisoes"), api.get("/disciplines")]);
    setItems(r.data);
    setDisciplines(d.data);
  };
  useEffect(() => { load(); }, []);

  const save = async () => {
    if (!form.discipline_id || !form.topic || !form.next_date) { toast({ title: "Preencha todos os campos" }); return; }
    await api.post("/revisoes", form);
    setOpen(false);
    setForm({ discipline_id: "", topic: "", next_date: "" });
    load();
  };
  const complete = async (id) => { await api.put(`/revisoes/${id}/complete`); load(); };
  const del = async (id) => { await api.delete(`/revisoes/${id}`); load(); };

  const today = new Date().toISOString().split("T")[0];
  const groups = { atrasadas: [], hoje: [], proximas: [], concluidas: [] };
  items.forEach((r) => {
    if (r.completed) groups.concluidas.push(r);
    else if (r.next_date < today) groups.atrasadas.push(r);
    else if (r.next_date === today) groups.hoje.push(r);
    else groups.proximas.push(r);
  });

  return (
    <div className="space-y-6 max-w-[1400px]">
      <div className="flex items-center justify-between">
        <h1 className="font-display text-3xl font-extrabold">Revisões</h1>
        <Button onClick={() => setOpen(true)} className="bg-tiffany-500 hover:bg-tiffany-600 text-white">
          <Plus size={16} className="mr-1" /> Nova Revisão
        </Button>
      </div>

      {Object.entries({ atrasadas: "Atrasadas", hoje: "Hoje", proximas: "Próximas", concluidas: "Concluídas" }).map(([k, label]) => (
        groups[k].length > 0 && (
          <div key={k} className="rounded-2xl bg-card border border-border p-5">
            <h3 className={`font-display font-bold mb-3 ${k === "atrasadas" ? "text-red-500" : k === "hoje" ? "text-tiffany-600" : "text-muted-foreground"}`}>
              {label} ({groups[k].length})
            </h3>
            <ul className="space-y-2">
              {groups[k].map((r) => (
                <li key={r.id} className="flex items-center gap-3 p-3 rounded-lg border border-border">
                  <div className="flex-1">
                    <div className="font-semibold">{r.topic}</div>
                    <div className="text-sm text-muted-foreground">{r.discipline_name} — {formatDateBR(r.next_date)}</div>
                  </div>
                  {!r.completed && (
                    <Button size="sm" variant="outline" onClick={() => complete(r.id)}>
                      <CheckCircle2 size={14} className="mr-1" /> Concluir
                    </Button>
                  )}
                  <button onClick={() => del(r.id)} className="text-red-500 p-1.5 hover:bg-red-50 rounded"><Trash2 size={14} /></button>
                </li>
              ))}
            </ul>
          </div>
        )
      ))}

      {items.length === 0 && (
        <div className="rounded-2xl border border-dashed border-border p-12 text-center text-muted-foreground">
          Nenhuma revisão programada.
        </div>
      )}

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent>
          <DialogHeader><DialogTitle>Nova Revisão</DialogTitle></DialogHeader>
          <div className="space-y-4">
            <Select value={form.discipline_id} onValueChange={(v) => setForm({ ...form, discipline_id: v })}>
              <SelectTrigger><SelectValue placeholder="Disciplina" /></SelectTrigger>
              <SelectContent>{disciplines.map((d) => <SelectItem key={d.id} value={d.id}>{d.name}</SelectItem>)}</SelectContent>
            </Select>
            <Input placeholder="Tópico" value={form.topic} onChange={(e) => setForm({ ...form, topic: e.target.value })} />
            <Input type="date" value={form.next_date} onChange={(e) => setForm({ ...form, next_date: e.target.value })} />
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)}>Cancelar</Button>
            <Button onClick={save} className="bg-tiffany-500 hover:bg-tiffany-600 text-white">Salvar</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
